import React from 'react';
import Input from '../../../components/ui/Input';
import Icon from '../../../components/AppIcon';
import { useTranslation } from 'react-i18next';

const PersonalInfoSection = ({
  firstName,
  lastName,
  onFirstNameChange,
  onLastNameChange,
  errors = {}
}) => {
  const { t } = useTranslation();

  return (
    <div className="bg-white rounded-lg shadow-md p-6">
      <div className="flex items-center space-x-3 mb-6">
        <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">
          <Icon name="User " size={20} className="text-blue-600" />
        </div>
        <div>
          <h2 className="text-lg font-semibold text-gray-800">
            {t("personalInformation")}
          </h2>
          <p className="text-gray-500 text-sm">
            {t("updatePersonalInfo")}
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <Input
            label={t("firstName")}
            type="text"
            value={firstName}
            onChange={(e) => onFirstNameChange(e.target.value)}
            placeholder={t("enterFirstName")}
            required
            error={errors.firstName}
          />
        </div>

        <div>
          <Input
            label={t("lastName")}
            type="text"
            value={lastName}
            onChange={(e) => onLastNameChange(e.target.value)}
            placeholder={t("enterLastName")}
            required
            error={errors.lastName}
          />
        </div>
      </div>
    </div>
  );
};

export default PersonalInfoSection;
